<div class="block pr-xsmall pr-clear-b white-bg surface-primary mr-xxsmall border rounded-large">
  <ng-container [ngTemplateOutlet]="fromFragment() ? fromFragment() : default" />
  <ng-template #default>
    <p class="font-body-1 font-body-medium">
      <ng-content select=".title" />
    </p>
  </ng-template>

  <div class="flex flex--end ms-small-b">
    <fcom-button
      data-testid="bound-selection-error-message-redirect-link"
      class="try-again-button ms-small-t"
      [theme]="ButtonTheme.LIGHT_PRIMARY_NORDIC_BLUE"
      [text]="ctaButtonText()"
      [icon]="{ name: SvgLibraryIcon.ARROW_RIGHT, position: IconPosition.RIGHT }"
      [mode]="ButtonMode.FILL_MOBILE"
      (clickBtn)="ctaClick.emit($event)"
    />
  </div>

  @if (enableSurvey() && qualtricsUrl$ | async) {
    <hr class="ms-small-y" />

    <div class="flex flex--end ms-small-b">
      <fcom-button
        data-testid="bound-selection-error-message-redirect-link"
        class="qualtrics-survey-button"
        [theme]="ButtonTheme.LIGHT_TERTIARY_GHOST"
        [text]="surveyButtonText() | finLocalization"
        [icon]="{ name: SvgLibraryIcon.EXTERNAL_TAB, position: IconPosition.RIGHT }"
        [mode]="ButtonMode.FILL_MOBILE"
        [href]="qualtricsUrl$ | async"
        [externalLink]="true"
        [openInNewTab]="true"
        [rel]="'noreferrer'"
      />
    </div>
  }
</div>
